import React from 'react';
import './InGameWindows.css'
import InGameValueCard from "../InGameValueCard";
import GameWindowHeader from "../GameWindowHeader";
import GameData from "../../../gameplay/model/GameData";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import GameController from "../../../gameplay/controllers/GameController";
import agent from "../../../agent";

export default class BalanceWindow extends React.Component {
    constructor() {
        super();
        this.state = {
            assets: 0,
            parts: 0,
            creditors: 0,
            debet: 0,
            credit: 0,
            cash: 0,
            capital: 0,
            profit: 0,
            gameData: null
        }

        let economyIndex = UtilsFunctions.getRoleNameIndex("Зам. по экономике и финансам");
        this.isFinanceDirector = UtilsFunctions.playerHasRole(economyIndex);
    }

    onChangeAssets(value) {
        this.setState({
            assets: Number(value)
        })
    }

    onChangeParts(value) {
        this.setState({
            parts: Number(value)
        })
    }

    onChangeCreditors(value) {
        this.setState({
            creditors: Number(value)
        })
    }

    onChangeDebet(value) {
        this.setState({
            debet: Number(value)
        })
    }

    onChangeCredit(value) {
        this.setState({
            credit: Number(value)
        })
    }

    onChangeCash(value) {
        this.setState({
            cash: Number(value)
        })
    }

    onChangeCapital(value) {
        this.setState({
            capital: Number(value)
        })
    }

    onChangeProfit(value) {
        this.setState({
            profit: Number(value)
        })
    }

    componentDidMount() {
        let currentGame = GameData.CurrentGame;
        if(currentGame.year > 0){
            agent.GamePlay.stat(this.props.teamID, currentGame.year - 1, resp => {
                let data = GameData.CreateGameData(resp);
                this.setState({
                    gameData: data
                });
                this.forceUpdate();
            })
        }
        else {
            this.setState({
                gameData: currentGame
            });
        }

    }

    componentWillUnmount() {
    }

    render() {
        if (!this.state.gameData)
            return "";

        let stats = GameController.calculateStatistics(this.state.gameData);
        let creditors = this.props.isEditable ? this.state.creditors : stats.creditDebt;
        let parts = this.props.isEditable ? this.state.parts : stats.partsSum;

        // if (!this.props.isEditable) {
        //     let repairShops = GameData.CurrentGame.getRepairShops();
        //     parts = 0;
        //     for (let i = 0; i < repairShops.length; i++) {
        //         parts += repairShops[i].partsCount * GetSparePartCost();
        //     }
        // }

        let capital = this.props.isEditable ? this.state.capital : stats.funders;
        let assets = this.props.isEditable ? this.state.assets : stats.main;
        let mainLeft = assets;
        let credit = this.props.isEditable ? this.state.credit : stats.creditBalance;
        let debet = this.props.isEditable ? this.state.debet : stats.debit;
        let cash = this.props.isEditable ? this.state.cash : stats.cash;

        let money = this.props.isEditable ? parts + debet + cash : stats.money;
        let actives = this.props.isEditable ? mainLeft + money : stats.actives;

        // нераспределенная
        // let profit = this.props.isEditable ? this.state.profit : GameData.CurrentGame.retainedEarnings;
        let profit = this.props.isEditable ? this.state.profit : stats.lastYearProfitBalance;

        let fullCapital = this.props.isEditable ? this.state.capital + this.state.profit : stats.fullCapital;
        let creditSum = this.props.isEditable ? credit + creditors : stats.creditsSum;
        let passives = this.props.isEditable ? creditSum + fullCapital : stats.passives;
        let debtAbility = this.props.isEditable ? passives - creditSum : stats.debtAbility ;

        let debtPercent = this.props.isEditable ?  Math.round(money / fullCapital * 100) : stats.debtPercent;
        return <div className="in-game-popup"
                    title={!this.isFinanceDirector ? "Заполнять баланс может только Зам. по экономике и финансам" : ""}
                    style={{
                        width: this.props.width,
                        height: this.props.height,
                        background: "rgba(0, 0, 0, 0.5)",
                        backdropFilter: "blur(5px)"
                    }}>
            <div className="in-game-balance-popup-bg">
                <GameWindowHeader width={1084} height={40} onHide={this.props.onHide} title={"Баланс"}
                                  isClosable={true}/>
                <div className="in-game-popup-balance-content">
                    <div className="in-game-balance-container-one">
                        <InGameValueCard className={"mb"} title={"АКТИВЫ"} height={20} type={0} subtype={0}/>

                        <InGameValueCard className={"mb"}  title={"Итого чистые основные средства"} height={20} type={0} subtype={0}
                                         onChange={this.onChangeAssets.bind(this)} value={assets} isEditable={this.isFinanceDirector && this.props.isEditable}/>
                        <div className="table">

                            <InGameValueCard title={"Оборотные средства"} value={money} height={20} type={0} subtype={0}/>
                            <InGameValueCard title={"Запасы/Запчасти"} value={parts} onChange={this.onChangeParts.bind(this)} isEditable={this.isFinanceDirector && this.props.isEditable} height={20} type={1} subtype={1}/>
                            <InGameValueCard title={"Дебиторская задолженность"} height={20} type={1}
                                             subtype={2} value={debet} onChange={this.onChangeDebet.bind(this)} isEditable={this.isFinanceDirector && this.props.isEditable}/>
                            <InGameValueCard title={"Наличные"} height={20} type={1} subtype={1} value={cash} onChange={this.onChangeCash.bind(this)}
                                                                     isEditable={this.isFinanceDirector && this.props.isEditable}/>
                        </div>
                        <div className="filler table" style={{marginBottom: "30px"}}>
                            <InGameValueCard title={"чистый оборотный капитал"} value={money} height={20} type={1} subtype={0}/>
                        </div>

                        <InGameValueCard className={"mb"}  title={"активы"} value={actives} height={20} type={0} subtype={0}/>

                        <InGameValueCard title={"долговая нагрузка"}
                                         value={`${debtPercent || 0}%`} height={20} type={0}
                                         subtype={0}/>
                    </div>
                    <div className="in-game-balance-container-two">
                    <InGameValueCard className={"mb"}  title={"ПАССИВЫ"} height={20} type={0} subtype={0}/>

                    <InGameValueCard title={"задолженность"} height={20} type={0} subtype={0}/>
                    <div className="mb">
                        <InGameValueCard title={"Кредиты и займы"} value={credit} height={20}
                                         type={1} subtype={1} onChange={this.onChangeCredit.bind(this)}
                                         isEditable={this.isFinanceDirector && this.props.isEditable} />
                        <InGameValueCard title={"Кредиторская задолженность"} value={creditors} height={20} type={1}
                                         subtype={2} onChange={this.onChangeCreditors.bind(this)}
                                         isEditable={this.isFinanceDirector && this.props.isEditable} />
                        <InGameValueCard title={"чистые заимствования"} value={creditSum} height={20} type={1}
                                         subtype={0} className={"mb"} />
                    </div>

                    <InGameValueCard title={"СОБСТВЕННЫЙ КАПИТАЛ"} height={20} type={0} subtype={0}/>
                    <div className="mb">
                        <InGameValueCard title={"Акционерный капитал"} value={capital} height={20} type={1}
                                         subtype={1} onChange={this.onChangeCapital.bind(this)}
                                         isEditable={this.isFinanceDirector && this.props.isEditable} />
                        <InGameValueCard title={"Нераспределенная прибыль"} value={profit} height={20} type={1}
                                         subtype={2} onChange={this.onChangeProfit.bind(this)}
                                         isEditable={this.isFinanceDirector && this.props.isEditable} />
                        <InGameValueCard title={"ВСЕГО СОБСТВЕННЫЙ КАПИТАЛ"} value={fullCapital} height={20} type={1}
                                         subtype={0} />
                    </div>

                    <InGameValueCard title={"пассивы"} className={"mb"} value={passives} height={20} type={0} subtype={0}/>

                    <InGameValueCard title={"заёмная возможность"} value={debtAbility.toLocaleString()} height={20} type={0}
                                     subtype={0}/>
                </div>
                </div>
            </div>
        </div>;
    }
}
